import React from 'react';
import VacancyCard from './VacancyCard';

import './styles.scss';

const BlockVacancies = ({ block }) => {
  const { items = [] } = block;

  return (
    <div className="block-vacancies">
      {items.map((item) => (
        <VacancyCard key={item.id} vacancy={item} />
      ))}
    </div>
  );
};

export default BlockVacancies;
